import React from 'react';

function DownloadButton({ blobUrl, isLoading, downloadFunction, children }) {
	if (!blobUrl && !isLoading) {
		return (
			<button className='btn btn-sm py-0' onClick={() => downloadFunction()}>
				<i className="fas fa-download" />
				{children}
			</button>
		);
	} else if (!blobUrl && isLoading) {
		return (
			<div className="btn btn-sm py-0">
				<div className='spinner-border spinner-border-sm' />
				{children}
			</div>
		);
	}

	return (
		<button className='btn btn-sm py-0' onClick={() => window.open(blobUrl, '_blank')}>
			<i className="fas fa-file-pdf" />
			{children}
		</button>
	);
}

export default DownloadButton;
